import React, { useCallback } from 'react';
import { Button } from '@cad-arc';
import { AttachmentDto } from '@mark43/cad-api';
import { useDownloadAttachment } from './hooks/use-download-attachment';
import { observer } from 'mobx-react-lite';
import { getDownloadUrl, getFileName, getFileSize } from './helpers';
import { AttachmentDownloadInfo } from './types';

export interface AttachmentDownloadButtonProps {
    attachment: AttachmentDto;
    onDownload?: (info: AttachmentDownloadInfo) => void;
}

export const AttachmentDownloadButton = observer(function AttachmentDownloadButton({
    attachment,
    onDownload,
}: AttachmentDownloadButtonProps): React.ReactElement {
    const fileName = getFileName(attachment);
    const fileUrl = getDownloadUrl(attachment);
    const fileSize = getFileSize(attachment);

    const handleDownloadStart = useCallback(
        function notifyDownloadStart() {
            onDownload?.({ attachmentId: attachment.attachmentId, fileName });
        },
        [onDownload, attachment.attachmentId, fileName]
    );

    const { downloadAttachment, isDownloading, progress } = useDownloadAttachment({
        attachmentId: attachment.attachmentId,
        fileName,
        fileUrl,
        fileSize,
        onDownloadStart: handleDownloadStart,
    });

    return (
        <Button
            variant="outline"
            onClick={downloadAttachment}
            flex={1}
            isDisabled={isDownloading}
        >
            {progress !== undefined ? `${progress}%` : 'Download'}
        </Button>
    );
});
